import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import db from '../firebaseConfig';
import { collection, query, where, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import '../styles.css';

function VendorManagement() {
  const { country } = useParams();
  const [vendors, setVendors] = useState([]);
  const [newVendorName, setNewVendorName] = useState('');

  const fetchVendors = async () => {
    const vendorsRef = collection(db, 'vendors');
    const q = query(vendorsRef, where('country', '==', country));
    const snapshot = await getDocs(q);
    const vendorList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setVendors(vendorList);
  };

  useEffect(() => {
    fetchVendors();
  }, [country, fetchVendors]);

  const handleAddVendor = async () => {
    if (!newVendorName.trim()) return;
    const vendorsRef = collection(db, 'vendors');
    await addDoc(vendorsRef, { name: newVendorName.trim(), country });
    setNewVendorName('');
    fetchVendors();
  };

  const handleDeleteVendor = async (vendorId) => {
    if(window.confirm("確定要刪除此廠商嗎？")) {
      await deleteDoc(doc(db, 'vendors', vendorId));
      fetchVendors();
    }
  };

  const pageStyle = {
    minHeight: '100vh',
    background: '#f8f9fa',
    padding: '1rem',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  };

  const cardStyle = {
    background: '#fff',
    borderRadius: '12px',
    padding: '1.5rem',
    marginBottom: '1rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    maxWidth: '480px',
    margin: '0 auto'
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    fontSize: '1rem',
    border: '1px solid #e5e5e5',
    borderRadius: '8px',
    boxSizing: 'border-box',
    marginBottom: '0.75rem'
  };

  const buttonStyle = {
    background: '#333',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.2s'
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1.5rem', color: '#333', textAlign: 'center' }}>廠商管理</h2>
        <input 
          type="text" 
          value={newVendorName} 
          onChange={(e) => setNewVendorName(e.target.value)} 
          placeholder="新增廠商名稱" 
          style={inputStyle}
        />
        <button 
          onClick={handleAddVendor}
          style={buttonStyle}
          onMouseOver={(e) => { e.target.style.background = '#555'; }}
          onMouseOut={(e) => { e.target.style.background = '#333'; }}
        >
          新增廠商
        </button>
        {vendors.length > 0 && (
          <div style={{ marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid #e5e5e5' }}>
            {vendors.map(vendor => (
              <div 
                key={vendor.id}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '0.75rem',
                  marginBottom: '0.5rem',
                  background: '#f8f9fa',
                  borderRadius: '8px'
                }}
              >
                <span style={{ fontSize: '1rem', color: '#333' }}>{vendor.name}</span>
                <button 
                  onClick={() => handleDeleteVendor(vendor.id)}
                  style={{
                    background: 'transparent',
                    color: '#ff4444',
                    border: '1px solid #ff4444',
                    borderRadius: '6px',
                    padding: '0.5rem 1rem',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => { e.target.style.background = '#ff4444'; e.target.style.color = '#fff'; }}
                  onMouseOut={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#ff4444'; }}
                >
                  刪除
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default VendorManagement;
